import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ValidateZipCode, ValidateZipCodeResponse } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface ValidateZipCodeParams extends DefaultHttpHeaders {}

@Injectable()
export class ValidateZipCodeService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Validate home ZipCode (CAP)
   * Validate home ZipCode (CAP). Quotation could be applied or not depending of the ZipCode.
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/postValidationZipCode
   */
  validateZipCode(body: ValidateZipCode, params: ValidateZipCodeParams): Observable<ValidateZipCodeResponse> {
    return this.post<ValidateZipCode, ValidateZipCodeResponse>({
      suffix: '/comeround/applicationUtilities/validateZipCode',
      body,
    });
  }
}
